<div id="check-certificate">
  <div class="mt-3 pt-2 mb-4">
    <p *ngIf="!isResultatenOphalenBezig">
      {{ "DOWNLOAD_EPHYTO.INFO_TEKST" | promptvalue | async }}
    </p>
    <div *ngIf="isResultatenOphalenBezig">
      <img
        id="waiting_spinner_results"
        class="waiting-spinner w-50"
        [class.hidden]="isResultatenOpgehaald()"
        src="assets/icons/loading-spinner.svg"
        alt="spinner"
      />
    </div>
  </div>

  <div
    *ngIf="getResultaatError() !== null && !isResultatenOphalenBezig"
    class="ephyto-error-wrapper"
  >
    <div class="danger ephyto-error">
      <div class="float-left">
        <div class="ephyto-error-header">{{ getResultaatError().header }}</div>
        <div class="ephyto-error-tekst">{{ getResultaatError().tekst }}</div>
      </div>
      <img
        src="assets/icons/ui-close-edit-box-red.svg"
        (click)="setResultaatError(null)"
        alt="close"
        class="float-right ephyto-error-close"
      />
    </div>
  </div>

  <div id="zoek-input-wrapper" [hidden]="isResultatenOphalenBezig">
    <div class="row">
      <label
        for="certificaat_nummer"
        class="col-label mt-1"
        style="position: static; top: 3px"
        >{{ "DOWNLOAD_EPHYTO.CERTIFICAAT_NUMMER" | promptvalue | async }}</label
      >
      <ecert-input
        [ref_object]="zoekparameters"
        action_identifier="certificaat-nummer"
        id="certificaat_nummer"
        [maxlength]="50"
        property="certificaatNummer"
        [hideLabel]="true"
        class="input col-input"
        style="padding-right: 35px"
        [tooltip]="getPrompt('DOWNLOAD_EPHYTO.CERTIFICAAT_NUMMER')"
      ></ecert-input>
    </div>

    <div class="row mt-2">
      <label for="land_van_afgifte" class="col-label mt-3">{{
        "DOWNLOAD_EPHYTO.LAND_VAN_AFGIFTE" | promptvalue | async
      }}</label>
      <ecert-autocomplete
        [opties]="landen"
        [optionLabelProperty]="'codeEnNaam'"
        [optionValueProperty]="'code'"
        [refObjectProperty]="'landVanAfgifte'"
        [ref_object]="zoekparameters"
        [hideLabel]="true"
        [error]="landVanAfgifteError"
        [volledigeBreedte]="false"
        id="land_van_afgifte"
        class="col-input"
        style="margin-left: -15px; padding-right: -20px"
        action_identifier="DOWNLOAD_EPHYTO.LAND_VAN_AFGIFTE"
      >
      </ecert-autocomplete>
    </div>
    <div class="row">
      <label
        for="datum_van_afgifte"
        class="col-label"
        style="position: static; top: 3px; margin-top: -10px"
        >{{ "DOWNLOAD_EPHYTO.DATUM_VAN_AFGIFTE" | promptvalue | async }}</label
      >
      <ecert-date
        id="datum_van_afgifte"
        [ref_object]="zoekparameters"
        [hideLabel]="true"
        property="datumVanAfgifte"
        style="margin-top: -26px"
      ></ecert-date>
    </div>

    <div class="row" style="margin-top: -20px">
      <label class="label col-label mt-1"></label>
      <canvas id="canvas" width="260" height="50"> </canvas>

      <button
        id="reload-button"
        (click)="reloadCaptchaText(false)"
        class="input button ml-auto mt-2 reload-button"
      >
        {{ "DOWNLOAD_EPHYTO.RELOAD_BUTTON" | promptvalue | async }}
      </button>
    </div>

    <div class="row mb-3">
      <label class="label col-label mt-1" for="captcha_input">{{
        "DOWNLOAD_EPHYTO.CAPTCHA_LABEL" | promptvalue | async
      }}</label>
      <ecert-input
        id="captcha_input"
        [ref_object]="captcha"
        property="captchaInput"
        class="input col-input captcha-input"
        [maxlength]="9"
        [error]="captchaError"
        foutmelding="DOWNLOAD_EPHYTO.CAPTCHA_FOUTMELDING"
        [clear_button]="false"
        [hideLabel]="true"
      >
      </ecert-input>
    </div>

    <div class="row mt-4 pt-2">
      <div class="label col-label"></div>
      <button
        id="verifieer_button"
        (click)="verifyInputValues()"
        class="input button ml-3 verifieer-button"
        [disabled]="findIsDisabled()"
      >
        {{ "DOWNLOAD_EPHYTO.ZOEK_BUTTON" | promptvalue | async }}
      </button>
    </div>
  </div>

  <div *ngIf="isResultatenOpgehaald() && !isResultatenOphalenBezig">
    <div id="zoek-result-wrapper" [hidden]="isResultatenOphalenBezig">
      <div class="row">
        <div class="col-8 mt-2">{{ resultatenTekst }}</div>
        <div class="pl-3 mr-3 ml-auto">
          <button
            (click)="openPdfCertificaat()"
            [class.saving_spinner]="spinnerpdf"
            [disabled]="!isPdfOpgehaald"
            class="wit mr-3 px-4 c-pointer"
          >
            <div class="py-1">
              {{ "DOWNLOAD_EPHYTO.OPEN_PDF_BUTTON" | promptvalue | async }}
            </div>
          </button>
          <button
            (click)="openXmlCertificaat()"
            [class.saving_spinner]="spinnerxml"
            [disabled]="!isXmlOpgehaald"
            class="wit px-4 c-pointer"
          >
            <div class="py-1">
              {{ "DOWNLOAD_EPHYTO.OPEN_XML_BUTTON" | promptvalue | async }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wrapper">
  <div class="footer-container">
    <div class="footer-section">
      <h1>{{ getPrompt("DOWNLOAD_EPHYTO.SERVICE") | promptvalue | async }}</h1>
      <p>
        <a
          target="_blank"
          rel="noopener"
          style="color: white"
          href="{{
            getPrompt('DOWNLOAD_EPHYTO.URL_CONTACT') | promptvalue | async
          }}"
        >
          {{ getPrompt("DOWNLOAD_EPHYTO.CONTACT") | promptvalue | async }}
        </a>
      </p>
    </div>
  </div>
</div>
